import React from "react";
import { TreePine, Flower2, HeartHandshake, ArrowRight } from "lucide-react";
import { T } from "@/context/LanguageContext";

const FT_URL = "https://familytree.team";
const ART = "https://images.unsplash.com/photo-1770310257376-0fc55e9f16c0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzZ8MHwxfHNlYXJjaHw0fHxnZW5lYWxvZ3klMjBmYW1pbHklMjB0cmVlJTIwaGlzdG9yeXxlbnwwfHx8fDE3ODk1MDgzNDZ8MA&ixlib=rb-4.1.0&q=85";

const FEATURES = [
  { icon: TreePine, title: "Family Tree Search", desc: "Trace local ancestry & lineages" },
  { icon: Flower2, title: "Local Obituaries", desc: "Recent & historical obituaries" },
  { icon: HeartHandshake, title: "Memorial Wall", desc: "Tributes & community remembrance" },
];

export function FamilyTreeHub({ placeName }) {
  const href = (path) => `${FT_URL}${path}`;
  return (
    <section data-testid="family-tree-hub"
      className="overflow-hidden rounded-2xl border-2 border-[#b7791f]/30 bg-parchment-light">
      <div className="grid md:grid-cols-[1.4fr_1fr]">
        <div className="p-5 sm:p-7">
          <div className="mb-1 inline-block rounded bg-[#b7791f]/15 px-2 py-0.5 text-[10px] font-bold uppercase tracking-widest text-[#8a5a12]">FamilyTree.team</div>
          <h2 className="font-display text-2xl font-black tracking-tight text-navy sm:text-3xl">
            <T>Family Tree · Obituaries · Memorials</T>
          </h2>
          <p className="mt-2 max-w-prose text-sm text-ink/80">
            <T>Discover ancestry, honor loved ones, and preserve the community memory of</T> {placeName}. <T>Genealogy records, local obituaries and memorial tributes — powered by our sister site FamilyTree.team.</T>
          </p>

          <div className="mt-5 grid gap-3 sm:grid-cols-3" data-testid="family-tree-features">
            {FEATURES.map((f) => {
              const Icon = f.icon;
              return (
                <a key={f.title} href={href("/")} target="_blank" rel="noopener noreferrer"
                  className="group rounded-xl border border-[#b7791f]/25 bg-white p-3.5 transition-all hover:-translate-y-0.5 hover:border-[#b7791f] hover:shadow-md"
                  data-testid={`family-tree-${f.title.toLowerCase().split(" ")[0]}`}>
                  <Icon className="mb-1.5 h-6 w-6 text-[#b7791f]" strokeWidth={1.6} />
                  <div className="font-display text-sm font-bold text-navy group-hover:text-[#8a5a12]"><T>{f.title}</T></div>
                  <div className="mt-0.5 text-[11px] text-muted-foreground"><T>{f.desc}</T></div>
                </a>
              );
            })}
          </div>

          <a href={FT_URL} target="_blank" rel="noopener noreferrer"
            className="mt-5 inline-flex items-center gap-2 rounded-full bg-navy px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-navy-800"
            data-testid="family-tree-cta">
            <T>Search Local Ancestry & Obituaries on FamilyTree.team</T> <ArrowRight className="h-4 w-4" />
          </a>
        </div>
        <div className="relative hidden min-h-[220px] md:block">
          <img src={ART} alt="Genealogy records" loading="lazy" className="absolute inset-0 h-full w-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-r from-parchment-light via-parchment-light/30 to-transparent" />
        </div>
      </div>
    </section>
  );
}
